/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { SecurityPasswordInputIcon16Light } from './SecurityPasswordInputIcon16Light';
import { SecurityPasswordInputIcon16Regular } from './SecurityPasswordInputIcon16Regular';
import { SecurityPasswordInputIcon16Solid } from './SecurityPasswordInputIcon16Solid';
import { SecurityPasswordInputIcon20Light } from './SecurityPasswordInputIcon20Light';
import { SecurityPasswordInputIcon20Regular } from './SecurityPasswordInputIcon20Regular';
import { SecurityPasswordInputIcon20Solid } from './SecurityPasswordInputIcon20Solid';
import { SecurityPasswordInputIcon24Regular } from './SecurityPasswordInputIcon24Regular';
import { SecurityPasswordInputIcon24Solid } from './SecurityPasswordInputIcon24Solid';
import { SecurityPasswordInputIcon32Regular } from './SecurityPasswordInputIcon32Regular';
import { SecurityPasswordInputIcon64Regular } from './SecurityPasswordInputIcon64Regular';
var sizes = {
    16: {
        light: SecurityPasswordInputIcon16Light,
        regular: SecurityPasswordInputIcon16Regular,
        solid: SecurityPasswordInputIcon16Solid,
    },
    20: {
        light: SecurityPasswordInputIcon20Light,
        regular: SecurityPasswordInputIcon20Regular,
        solid: SecurityPasswordInputIcon20Solid,
    },
    24: {
        regular: SecurityPasswordInputIcon24Regular,
        solid: SecurityPasswordInputIcon24Solid,
    },
    32: {
        regular: SecurityPasswordInputIcon32Regular,
    },
    64: {
        regular: SecurityPasswordInputIcon64Regular,
    },
};
export var SecurityPasswordInputIcon = forwardRef('SecurityPasswordInputIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
